import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {NewGameService} from "../../../services/new-game.service";
import {DateService} from "../../../services/date.service";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {IGameNotificationSettingsForm} from "../../../interfaces/new-game/forms/IGameNotificationForm";
import {MatError, MatFormField, MatHint, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {NgIf} from "@angular/common";
import {MatCheckbox} from "@angular/material/checkbox";

@Component({
  selector: 'app-game-notification-settings-form',
  standalone: true,
  imports: [
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatHint,
    MatError,
    MatInput,
    NgIf,
    MatCheckbox
  ],
  templateUrl: './game-notification-settings-form.component.html',
  styleUrl: './game-notification-settings-form.component.css'
})
export class GameNotificationSettingsForm implements OnInit {

  private newGameService: NewGameService = inject(NewGameService);
  private dateService: DateService = inject(DateService);

  private militaryTime: RegExp = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

  @Input() newGameNotificationSettingsForm: FormGroup<IGameNotificationSettingsForm> = new FormGroup<IGameNotificationSettingsForm>({
    notificationsBeginMinutesBeforeDraw: new FormControl<string>('', [Validators.required, Validators.pattern(this.militaryTime)]),
    notificationsEndMinutesBeforeDraw: new FormControl<string>('', [Validators.required, Validators.pattern(this.militaryTime)]),
    notificationFrequency: new FormControl<number>(3600, [Validators.required, Validators.min(1)]),
    notificationChunkSize: new FormControl<number>(100, [Validators.required, Validators.min(1)]),
    sendLastFourDigits: new FormControl<boolean>(false)
  });

  @Output() newGameNotificationSettingsFormChange: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  ngOnInit(): void {
    this.populateNotificationSettingsFromState()
  }

  onFormChange() {
    this.newGameNotificationSettingsFormChange.emit(this.newGameNotificationSettingsForm)
  }

  private populateNotificationSettingsFromState() {
    const newGameNotificationFromState = this.newGameService.getNewGameRequest()?.newGameNotification;
    const drawTimeMinutesFromMidnightLocal = this.newGameService.getNewGameRequest()?.newGameDraw?.drawTimeMinutesFromMidnightLocal;

    if (newGameNotificationFromState && drawTimeMinutesFromMidnightLocal) {
      if (newGameNotificationFromState.notificationsBeginMinutesBeforeDraw) {
        this.newGameNotificationSettingsForm.controls.notificationsBeginMinutesBeforeDraw
          .setValue(this.dateService.convertToMilitaryTime(drawTimeMinutesFromMidnightLocal - newGameNotificationFromState.notificationsBeginMinutesBeforeDraw));
      }

      if (newGameNotificationFromState.notificationsEndMinutesBeforeDraw) {
        this.newGameNotificationSettingsForm.controls.notificationsEndMinutesBeforeDraw
          .setValue(this.dateService.convertToMilitaryTime(drawTimeMinutesFromMidnightLocal - newGameNotificationFromState.notificationsEndMinutesBeforeDraw));
      } else if (newGameNotificationFromState.notificationsEndMinutesBeforeDraw === 0) {
        this.newGameNotificationSettingsForm.controls.notificationsEndMinutesBeforeDraw
          .setValue(this.dateService.convertToMilitaryTime(drawTimeMinutesFromMidnightLocal));
      }

      if (newGameNotificationFromState.notificationFrequency) {
        this.newGameNotificationSettingsForm.controls.notificationFrequency.setValue(newGameNotificationFromState.notificationFrequency);
      }

      if (newGameNotificationFromState.notificationChunkSize) {
        this.newGameNotificationSettingsForm.controls.notificationChunkSize.setValue(newGameNotificationFromState.notificationChunkSize);
      }

      if (newGameNotificationFromState.sendLastFourDigitsOfWinningCreditCardToOrganization) {
        this.newGameNotificationSettingsForm.controls.sendLastFourDigits.setValue(newGameNotificationFromState.sendLastFourDigitsOfWinningCreditCardToOrganization);
      }
    }

    this.newGameNotificationSettingsFormChange.emit(this.newGameNotificationSettingsForm);
  }
}
